export default {
    name: 'User List',
    path: '/offerUserList',
    meta: {
        icon: 'subject',
        expanded: true,
        auth: true,
        hasPermission: false
    },
    component: require('../components/view/offerUsersList/offerUserList.vue')
    // name: 'User Management',
    // meta: {
    //     icon: 'subject',
    //     expanded: true,
    //     auth: true,
    //     hasPermission: false
    // },
    // children: [
    //     {
    //         name: 'Excel Sheet Logs',
    //         path: '/excelsheelogs',
    //         meta: {
    //             link: 'ExcelSheetLogs/ExcelSheetAllLogs.vue',
    //             auth: true
    //         },
    //         component: require('../component/view/ExcelSheetLogs/ExcelSheetAllLogs.vue')
    //     },
    // ]
}


// WEBPACK FOOTER //
// ./src/sidebar/offerUserList.js